import {
    GET_INDUSTRY_LIST_PROGRESS, GET_INDUSTRY_LIST_SUCCESS, GET_INDUSTRY_LIST_FAILURE,
    ADD_INDUSTRY_PROGRESS, ADD_INDUSTRY_SUCCESS, ADD_INDUSTRY_FAILURE,
    EDIT_DELETE_INDUSTRY_PROGRESS, EDIT_DELETE_INDUSTRY_SUCCESS, EDIT_DELETE_INDUSTRY_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    industry: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const industry_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_INDUSTRY_LIST_SUCCESS:
            return { ...state, industry: action.industry, loading: false };
        case GET_INDUSTRY_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_INDUSTRY_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_INDUSTRY_PROGRESS:
            return { ...state, loading: true };
        case ADD_INDUSTRY_SUCCESS:
            return { ...state, industry: [...state.industry, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_INDUSTRY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_INDUSTRY_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_INDUSTRY_SUCCESS:
            return {
                ...state,
                industry: state.industry.map((industry) =>
                    industry.id === action.payload.id ? action.payload : industry
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_INDUSTRY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default industry_reducer;